import React from 'react';
import {useTranslation} from 'react-i18next';

import {Check} from '../icons';
import {CLARITY_UNMASK} from '../../utils/clarity/unmask';

/**
 * Los cuatro pasos del recorrido, siempre a la vista.
 *
 * El primero ("Tu agencia") ya está hecho cuando el túnel arranca: el usuario acaba de completar el
 * registro. Mostrarlo igual, tildado, es lo que convierte al recorrido en algo que ya empezó en vez
 * de una lista de tareas que recién comienza.
 */

export const ONBOARDING_STEPS = ['agency', 'platforms', 'clients', 'budgets'];

/**
 * `steps` y `labelPrefix` existen para el wizard de «Nueva línea de control», que usa el mismo
 * marco con otros cuatro pasos. Sin pasarlos, el stepper es el del túnel de siempre.
 */
export function Stepper({current, steps = ONBOARDING_STEPS, labelPrefix = 'onboarding.stepper'}) {
    const {t} = useTranslation();
    const currentIndex = steps.indexOf(current);

    return (
        <ol className="ob-stepper" aria-label={t('onboarding.stepper.label', 'Tu progreso')}>
            {steps.map((step, index) => {
                const isDone = currentIndex === -1 ? true : index < currentIndex;
                const isCurrent = index === currentIndex;
                return (
                    <li key={step}
                        className={`ob-step${isDone ? ' -done' : ''}${isCurrent ? ' -current' : ''}`}
                        aria-current={isCurrent ? 'step' : undefined}>
                        <span className="ob-step__dot">
                            {isDone ? <Check size={12} weight="bold"/> : index + 1}
                        </span>
                        <span className="ob-step__label" {...CLARITY_UNMASK}>{t(`${labelPrefix}.${step}`)}</span>
                    </li>
                );
            })}
        </ol>
    );
}
